import { render, staticRenderFns } from "./ResultTrend.vue?vue&type=template&id=2d485cc0&scoped=true&"
import script from "./ResultTrend.vue?vue&type=script&lang=js&"
export * from "./ResultTrend.vue?vue&type=script&lang=js&"
import style0 from "./ResultTrend.vue?vue&type=style&index=0&id=2d485cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d485cc0",
  null
  
)

export default component.exports